// extracted by mini-css-extract-plugin
export default {"loadMoreBtnWrapper":"LoadMoreButton_loadMoreBtnWrapper__BgD+s","btn":"LoadMoreButton_btn__jT+S3"};